import { TableHeadersType } from "./tableHeadersType";

export const USER_WISE_INNER_HEADERS: TableHeadersType[] = [
  { label: "Date", value: "date", width: "500px" },
  { label: "Expenses", value: "expenses", width: "300px" },
  { label: "Sales", value: "sales", width: "300px" },
  { label: "Total", value: "total", width: "300px" },
];
export const CLIENT_WISE_INNER_HEADERS: TableHeadersType[] = [
  { label: "USER", value: "user", width: "500px" },
  { label: "Expenses", value: "expenses", width: "300px" },
  { label: "Sales", value: "sales", width: "300px" },
  { label: "Total", value: "total", width: "300px" },
];

export const ALL_USER_WISE_HEADER: TableHeadersType[] = [
  // {
  //   label: "",
  //   value: "accordian",
  //   width: "30px",
  // },
  {
    label: "USER ",
    value: "user_name",
  },
  {
    label: "EXPENSES",
    value: "expenses",
  },
  {
    label: "SALES",
    value: "sales",
  },
  {
    label: "TOTAL",
    value: "total",
  },
];

export const ALL_CLIENT_WISE_HEADER: TableHeadersType[] = [
 
  {
    label: "CLIENT NAME ",
    value: "client_name",
  },
  {
    label: "EXPENSES",
    value: "expenses",
  },
  {
    label: "SALES",
    value: "sales",
  },
  {
    label: "TOTAL",
    value: "total",
  },
];
